import * as React from "react";
function SvgPages(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M22 28v2a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h2" />
        <path d="M10 23V4.5H8a1 1 0 00-1 1v21a1 1 0 001 1h16a1 1 0 001-1V24H11a1 1 0 01-1-1z" />
        <path d="M25 24h2a1 1 0 001-1V5l-4-4H11a1 1 0 00-1 1v2.5" />
        <path d="M23 1v4a1 1 0 001 1h4" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPages);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
